import { useRedux } from "hooks"
import { useEffect, useState } from "react";
import { loadDllEmployee } from "../redux/workplace/wpActions";
import { WpSliceData } from "../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";
import SelectDropdown from "./SelectDropdown";
import { APIClient } from "api/apiCore";
import * as urls from "../api/urls";


interface SelectDropdownMonthProps {
  onSelectMonths: (months: number[] | null) => void;
  selectedMonths?: number[] | null;
  isDisabled: boolean;
}

const SelectDropdownMonth = ({ selectedMonths, onSelectMonths, isDisabled }: SelectDropdownMonthProps) => {
  const months = Array.from({ length: 12 }, (_, i) => {
    const date = new Date(2024, i, 1); // year doesn't matter
    const label = new Intl.DateTimeFormat("th-TH", { month: "long" }).format(date);
    const value = i + 1; // usually months are 1–12
    return { label, value };
  });
  // console.log('date:', dates);

  return (
    <SelectDropdown
      isDisabled={isDisabled}
      isMulti={true}
      list={months}
      onValueChanged={(e) => { onSelectMonths(e.map((x: any) => x.value)) }}
      selectedValue={months.filter(x1 => selectedMonths?.includes(x1.value))}
    />
  )
}

export default SelectDropdownMonth

